export default __webpack_public_path__ + "static/media/dz.90e9e64c.jpg";